import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/paper_type', component: List, name: 'paper_type.index'},
  {path: '/paper_type/store', component: Form, name: 'paper_type.store'},
  {path: '/paper_type/:id', component: Form, name: 'paper_type.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/paper_type/routes.js